import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./About.css";

export const About = () => {
    return (
        <div className="about-page">
            <Helmet>
                <title>mustardtiger.xyz</title>
                <meta
                    name="description"
                    content="FPV hobbyist and software developer with a passion for RF and embedded systems. ExpressLRS developer and creator of FormationFlight."
                />

                {/* Open Graph Tags */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://mustardtiger.xyz" />
                <meta property="og:title" content="mustardtiger.xyz" />
                <meta
                    property="og:description"
                    content="FPV hobbyist and software developer with a passion for RF and embedded systems. ExpressLRS developer and creator of FormationFlight."
                />
                <meta
                    property="og:image"
                    content="https://mustardtiger.xyz/og-image.png"
                />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />

                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://mustardtiger.xyz" />
                <meta name="twitter:title" content="mustardtiger.xyz" />
                <meta
                    name="twitter:description"
                    content="FPV hobbyist and software developer with a passion for RF and embedded systems. ExpressLRS developer and creator of FormationFlight."
                />
                <meta
                    name="twitter:image"
                    content="https://mustardtiger.xyz/og-image.png"
                />
            </Helmet>
            <div className="terminal-window">
                <div className="terminal-output">
                    <div className="prompt-line">
                        <span className="prompt">$</span>
                        <span className="command">cat about.txt</span>
                    </div>

                    <div className="output-content">
                        <h1>$ whoami</h1>
                        <p>
                            FPV hobbyist and software developer with a passion
                            for RF and embedded systems.{" "}
                            <a href="https://expresslrs.org">
                                ExpressLRS developer
                            </a>
                            , creator of{" "}
                            <a href="formationflight.org">FormationFlight</a>,
                            and an expert in radio systems.
                        </p>

                        <h2>$ ls -la contents/</h2>
                        <ul className="feature-list">
                            <li>
                                <span className="text-green">
                                    <a
                                        className="btn"
                                        href="https://tools.mustardtiger.xyz/"
                                    >
                                        MUSTARDTIGER's Tools
                                    </a>
                                    : a collection of web-based tools for FPV,
                                    RF, and more.
                                </span>
                            </li>
                            <li>
                                <span className="text-purple">
                                    <a href="/posts">Posts</a>: Technical notes
                                    and ramblings on my projects
                                </span>
                            </li>
                        </ul>

                        <h2>$ cat navigation.md</h2>
                        <div className="help-box">
                            <div className="help-item">
                                <span className="key-combo">j / k</span>
                                <span className="key-desc">
                                    Scroll down / up
                                </span>
                            </div>
                            <div className="help-item">
                                <span className="key-combo">gg</span>
                                <span className="key-desc">Jump to top</span>
                            </div>
                            <div className="help-item">
                                <span className="key-combo">G</span>
                                <span className="key-desc">Jump to bottom</span>
                            </div>
                            <div className="help-item">
                                <span className="key-combo">/</span>
                                <span className="key-desc">Search posts</span>
                            </div>
                        </div>

                        <h2>$ echo $STACK</h2>
                        <p className="tech-stack">
                            Built with{" "}
                            <span className="text-accent">React</span>,{" "}
                            <span className="text-purple">Vite</span>, and
                            inspired by <a href="https://charm.land">Charm</a>.
                        </p>

                        <h2>$ next</h2>

                        <div className="cta">
                            <p>Ready to dive in?</p>
                            <Link to="/posts" className="cta-button">
                                <div className="cta-command">
                                    <span className="prompt">$</span>
                                    <span className="command">cd /posts</span>
                                    <span className="cursor"></span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
